import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomeScreen from './HomeScreen';

import PrivacyScreen from './PrivacyScreen';
import ContactScreen from './ContactScreen';
import Header from './Header';


function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/privacy_policy" element={<PrivacyScreen />} />
            <Route path="/contact_us" element={<ContactScreen />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
